module.exports = __webpack_public_path__ + "img/bluetooth_off.e28040bc.svg";